import React, { useEffect, useState } from 'react';

import { PlCapsuleConfigState } from '../store/config/PlCapsuleConfigState';
import ReactCardFlip from 'react-card-flip';
import { PlCapsuleChart } from './chart/PlCapsuleChart';
import { PlCapsuleValues } from './values/PlCapsuleValues';
import { PlData } from 'widgets/plCapsule/plCapsuleData';

import './PlCapsuleContent.scss';

interface PlCapsuleContentProps {
    symbol?: string;
    capsuleKey: string;
    data?: PlData;
    config: PlCapsuleConfigState;
    dispatchConfigChanged: (configDelta: Partial<PlCapsuleConfigState>) => void;
}
export function PlCapsuleContent(props: PlCapsuleContentProps) {
    const { config, dispatchConfigChanged, symbol, capsuleKey, data } = props;
    const { view, hideRealized, showUnrealized, showTotal } = config;

    const [time, setTime] = useState<number | undefined>();

    useEffect(() => {
        setTime(undefined);
    }, [symbol]);

    const isFlipped = view === 'values';

    if (!data) {
        return <div className="PlCapsuleContent">No data</div>;
    }

    const onChartClick = (nextTime?: number) => {
        setTime(nextTime);
        if (nextTime !== undefined) {
            dispatchConfigChanged({ view: 'values' });
        }
    };

    return (
        <div className="PlCapsuleContent">
            <ReactCardFlip isFlipped={isFlipped} flipDirection={'vertical'}>
                <PlCapsuleChart
                    key="front"
                    data={data}
                    hideRealized={hideRealized}
                    showUnrealized={showUnrealized}
                    showTotal={showTotal}
                    onClick={onChartClick}
                    chartKey={capsuleKey}
                />
                <PlCapsuleValues
                    key="back"
                    data={data}
                    time={time!}
                    onClick={() => dispatchConfigChanged({ view: 'chart' })}
                />
            </ReactCardFlip>
        </div>
    );
}
